var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIconMonochromeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166,60.1c.11,1.55.11,3.1.11,4.67,0,47.71-36.32,102.74-102.74,102.74v0A102.19,102.19,0,0,1,8,151.29a74.73,74.73,0,0,0,8.59.52,72.46,72.46,0,0,0,44.85-15.49,36.13,36.13,0,0,1-33.73-25.07,36.06,36.06,0,0,0,16.3-.62,36.12,36.12,0,0,1-29-35.4v-.45a35.93,35.93,0,0,0,16.39,4.51A36.14,36.14,0,0,1,20.26,31.08,102.51,102.51,0,0,0,94.67,68.81a36.15,36.15,0,0,1,61.54-32.94,72.47,72.47,0,0,0,22.93-8.76,36.31,36.31,0,0,1-15.88,20A71.89,71.89,0,0,0,184,41.39,73.36,73.36,0,0,1,166,60.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIconMonochromeDark);
export default __webpack_public_path__ + "static/media/twitter-icon-monochrome-dark.daae7b6db42c6124bab10b6d651ee8cb.svg";
export { ForwardRef as ReactComponent };